export const createQuantityInput = (element) => {
  if (!element || element.length === 0) {
    return null;
  }

  const instance = {
    $element: null,
    $quantityField: null,
    $quantityBtnMinus: null,
    $quantityBtnPlus: null,
    value: 1,
    minQuantity: 1,
    maxQuantity: 10,
    init: function (element) {
      this.$element = jQuery(element);
      this.$quantityField = this.$element.find(".js-quantity-field");
      this.$quantityBtnMinus = this.$element.find(".js-quantity-btn-minus");
      this.$quantityBtnPlus = this.$element.find(".js-quantity-btn-plus");
      this.value = this.$quantityField.val() || 1;
      this.minQuantity = this.$quantityField.attr("min") || 1;
      this.maxQuantity = this.$quantityField.attr("max") || 10;
      this.setupEventListeners();
    },
    setChangeCallback: function (callback) {
      this.$quantityField.on("change", callback);
    },
    setupEventListeners: function () {
      this.$quantityBtnMinus.on("click", () => this.decrementQuantity());
      this.$quantityBtnPlus.on("click", () => this.incrementQuantity());
    },
    decrementQuantity: function () {
      const currentQuantity = parseInt(this.$quantityField.val());
      if (currentQuantity > this.minQuantity) {
        this.$quantityField.val(currentQuantity - 1);
        this.$quantityField.trigger("change");
      }
    },
    incrementQuantity: function () {
      const currentQuantity = parseInt(this.$quantityField.val());
      if (currentQuantity < this.maxQuantity) {
        this.$quantityField.val(currentQuantity + 1);
        this.$quantityField.trigger("change");
      }
    },
    getValue: function () {
      return this.$quantityField.val();
    },
  };

  instance.init(element);
  return instance;
};
